<script>
  if (window.self === window.top) {
  } else {
    var emptyDiv = document.createElement("div");
    emptyDiv.innerHTML = "";
    document.body.append(emptyDiv);
  }
</script>

<app-sub-menu [subMenus]="subMenus"></app-sub-menu>
<div class="container-fluid bg-box configuracion">
  <h3>{{ title }}</h3>
  <hr />

  <div class="row mt-4 pasos">
    <div class="col-12 d-flex justify-content-sm-center">
      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>1</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">
            Nombre y ponderación
          </p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>2</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">Bloques y rubros</p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>3</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">Preguntas</p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>4</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">
            Tipos de respuesta
          </p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--active d-flex justify-content-sm-center align-items-center"
        >
          <span>5</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--active text-center mt-2">
            Configuración de respuestas
          </p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>6</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">
            Reglas de negocio
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <p>
      <button
        class="btn btn-sm btn-primary rounded-circle"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseExample"
        aria-expanded="false"
        aria-controls="collapseExample"
      >
        <i class="fa fa-info-circle" aria-hidden="true"></i>
      </button>
    </p>
    <div class="collapse" id="collapseExample">
      <div class="card card-body">
        <p style="text-align: justify">
          La ponderación de las preguntas, será el porcentaje que llenara en la
          aplicación del Rubro. Ejemplo, 1 Bloque con ponderación de 50%, con
          dos Rubros con ponderación de 25% y cada uno con dos preguntas, cada
          pregunta toma el 25% del valor del Rubro, para cuando se contesten las
          preguntas cumplan en 100%
        </p>
      </div>
    </div>
  </div>
  <div class="row mt-5 mb-3">
    <div class="col">
      <h3>Listado de respuestas</h3>
      <p>Agregar las ponderaciones correspondientes por respuesta</p>
    </div>
    <div class="col text-right">
      <a
        routerLink="../../../ChecklistPaso6/{{ idChecklist }}/{{ idTipoRevision }}"
        type="button"
        class="btn btn-sm btn-primary"
        ><i class="fa fa-arrow-right"></i> Continuar</a
      >
    </div>
  </div>
  <div class="card mt-2" *ngFor="let bloque of bloques">
    <div class="card-body">
      <h3 class="card-title">Bloque: {{ bloque.Nombre }}</h3>
      <div class="card mt-2" *ngFor="let rubro of bloque.Rubros">
        <div class="card-body">
          <h6 class="card-title">Rubro: {{ rubro.Nombre }}</h6>
          <form (submit)="frmPostRespuestas(rubro)" ngNativeValidate>
            <div class="card mt-2" *ngFor="let pregunta of rubro.Preguntas">
              <div class="card-body">
                <p class="card-title">{{ pregunta.Descripcion }}</p>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th style="width: 300px">Etiqueta</th>
                      <th style="width: 100px">Ponderación</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let respuesta of pregunta.Respuestas">
                      <td>{{ respuesta.Label }}</td>
                      <td>
                        <input
                          name="input{{ respuesta.IdRelacion }}"
                          [disabled]="[1].includes(respuesta.IdTipoInput)"
                          class="form-control form-control-sm"
                          type="number"
                          [(ngModel)]="respuesta.Ponderacion"
                          (keypress)="ValidaPonderacion($event)"
                          min="0"
                          max="100"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div *ngIf="rubro.Preguntas.length > 0" class="row mt-2">
              <div class="col text-right">
                <button [disabled]="disabledBtnResp" type="submit" class="btn btn-sm btn-primary">
                  <i class="fa fa-save"></i> Guardar rubro
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
